<header>
  <h2>{{registrationWelcomeTitle}}</h2>
  <p>{{registrationWelcomeBlurb}}</p>
</header>
<ng-template dynamicComponentHost></ng-template>
